(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["new-customer-starter-kit"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('new-customer-gift-content')) {
    class NewCustomerGiftContent extends HTMLElement {
      connectedCallback() {
        this.modal = this.closest('modal-dialog');
        this.loadingStatus = this.querySelector('[data-loading-status]');
        this.content = this.querySelector('[data-loaded-content]');
        this.error = this.querySelector('[data-loading-error]');
        this.loaded = false;
        this.loading = false;

        if (!this.modal) return;

        this.observer = new MutationObserver(() => {
          if (this.modal.hasAttribute('open')) this.load();
        });
        this.observer.observe(this.modal, { attributes: true, attributeFilter: ['open'] });

        if (this.modal.hasAttribute('open')) this.load();
      }

      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
      }

      async load() {
        if (this.loaded || this.loading) return;
        this.loading = true;
        this.modal.setAttribute('data-loading', 'true');

        try {
          const response = await fetch(this.dataset.sourceUrl, {
            credentials: 'same-origin',
            headers: { 'X-Requested-With': 'XMLHttpRequest' }
          });
          if (!response.ok) throw new Error(`Request failed with status ${response.status}`);

          const html = await response.text();
          const documentFragment = new DOMParser().parseFromString(html, 'text/html');
          const sourceSection = documentFragment.querySelector('.section-new-customer-gifts');
          if (!sourceSection) throw new Error('New Customer Gift section was not found');

          this.content.replaceChildren(sourceSection);
          this.content.hidden = false;
          this.loadingStatus.hidden = true;

          this.content.querySelectorAll('script').forEach((oldScript) => {
            const script = document.createElement('script');
            Array.from(oldScript.attributes).forEach((attribute) => {
              script.setAttribute(attribute.name, attribute.value);
            });
            script.textContent = oldScript.textContent;
            oldScript.replaceWith(script);
          });

          this.loaded = true;
        } catch (error) {
          console.error('[New customer gift modal]', error);
          this.loadingStatus.hidden = true;
          this.error.hidden = false;
        } finally {
          this.loading = false;
          this.modal.removeAttribute('data-loading');
        }
      }
    }

    customElements.define('new-customer-gift-content', NewCustomerGiftContent);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product-warranty-badge"] && !Shopify.designMode) return;
  try {
    (function() {
  if (window.__wbDedupDone) return;
  window.__wbDedupDone = true;
  document.querySelectorAll('.warranty-badge svg').forEach(function(svg, svgIdx) {
    svg.querySelectorAll('linearGradient[id]').forEach(function(g) {
      var oldId = g.id;
      var newId = oldId + '__' + svgIdx;
      g.id = newId;
      var re = new RegExp('url\\(#' + oldId.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\)', 'g');
      svg.querySelectorAll('[fill]').forEach(function(el) {
        var f = el.getAttribute('fill');
        if (f && re.test(f)) el.setAttribute('fill', f.replace(re, 'url(#' + newId + ')'));
      });
    });
  });
})();
  } catch(e) { console.error(e); }
})();

})();
